"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _div, _FakeCaret;
const FakeCaret = () => {
  return _div || (_div = /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "absolute pointer-events-none inset-0 flex items-center justify-center animate-caret-blink",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "w-px h-800 bg-white-normal"
    })
  }));
};
const Slot = props => /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
  className: `relative box-border h-[44px] w-[36px] border rounded-150 me-400 p-300 flex items-center transition-all duration-300 last:me-0 ${props.isActive ? "border-blue-normal" : "border-cloud-dark"}`,
  children: [props.char !== null && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    children: props.char
  }), props.hasFakeCaret && (_FakeCaret || (_FakeCaret = /*#__PURE__*/(0, _jsxRuntime.jsx)(FakeCaret, {})))]
});
var _default = exports.default = Slot;